/* Change this file to get your personal Porfolio */
const greeting = {
  /* Your Summary And Greeting Section */
  title: "Hi, I'm Neville",
  subTitle:
    "Performance-driven and motivated Full Stack Developer with extensive experience in participating in all phases of software development. Possess a strong attention to detail, well-developed time management skills, and ability to complete all projects within schedule and in a timely manner.",
  resumeLink: "https://drive.google.com/file/d/1jQZt3pQdKHRV96WggPWWmMQvNv6IyzCE/view?usp=sharing",
  
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/NevilDabre",
  linkedin: "https://www.linkedin.com/in/nevilledabre/",
  gmail: "neville.dabre@gmail.com",
  medium: "https://medium.com/@nevilledabreo",
  facebook: "https://www.facebook.com/neville.dabreo"
};

const skillsSection = {
  /* Your Skills Section  */
  title: "What i do",
  subTitle: "FULL STACK DEVELOPER WHO WANT TO EXPLORE EVERY TECH STACK",
  skills: [
    "⚡ Develop highly interactive Front end / User Interfaces for your web and backend applications",
    "⚡ Full stack applications with amazing utilities",
    "⚡ Integration of third party services such as AWS / Digital Ocean / JenKins / CircleCi & More",
    "⚡ Extensive experience using multiple standard programming languages",
  ],

  /* Make Sure You include correct Font Awesome Classname to view your icon */
  /* https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "linux",
      fontAwesomeClassname: "fab fa-linux"
    },
    {
      skillName: "jenkins",
      fontAwesomeClassname: "fab fa-jenkins"
    },
    {
      skillName: "mongo-db",
      fontAwesomeClassname: "fab fa-mdb"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
  ]
};

const openSource = {
  /* Your Open Source Section to View Your Github Pinned Projects */
  /* To know how to get github key look at readme.md */

  githubConvertedToken: "ZTdkN2FkMjY5MzMxNTU4MTI5NjQzOWI1MTg1NjQ4MjBiYmNjYmExMg==",
  githubUserName: "NevilDabre"
};

const bigProjects = {
  /* Some Big Projects You have worked with your company */
  title: "Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELP TO CREATE THEIR ONLINE RECEIPE",
  projects: [
    {
      title: "Waterloo Driving School",
      image: "https://waterloodrivingschool.herokuapp.com//img/logo-blue.png",
      footerLink: [{ name: "Driving school website to book appointments.", url: "https://waterloodrivingschool.herokuapp.com/" }]
    },
    {
      title: "NPK Digital Marketing",
      image: "https://npkdigitalmarketing.herokuapp.com/assets/images/letter-n-png-picture-122x101.png",
      footerLink: [{ name: "Digital marketing website to represent client.", url: "https://npkdigitalmarketing.herokuapp.com/" }]
    },
    {
      title: "Toolpro Engineering",
      image: "https://i.pinimg.com/originals/2f/f3/88/2ff388280f674bcc4f20b3ec440a7bed.jpg",
      footerLink: [{ name: "Engineering company website to repersent their tool portfolio.", url: "https://toolproengineering.herokuapp.com/" }]
    },
    {
      title: "NPK Canada Consulting",
      image: "https://npkcanadaconsultingwebsite.herokuapp.com/assets/images/icon-122x122.png",
      footerLink: [{ name: "Consulting company for Canada Visa and PR processing.", url: "http://npkcanadaconsultingwebsite.herokuapp.com/" }]
    },
  ]
};

const achievementSection = {
  /* Your Achievement Section Include Your Certification Talks and More */

  title: "Achievements And Certifications 🏆 ",
  subtitle: "Achievements, Certifications Award Letters and Some Cool Stuff that i have done !",

  achivementsCards: [
    {
      title: "Google Code-In Finalist",
      description: "First Pakistani to be selected as Google Google-in Finalist from 4000 students from 77 diffrent countries",
      image:
        "https://1.bp.blogspot.com/-Ig-v1tDXZt4/XDODmZvWp1I/AAAAAAAAB0A/KtbFdBPFVQw2O15FekkIR0Yg8MUp--rngCLcBGAs/s1600/GCI%2B-%2BVertical%2B-%2BGray%2BText%2B-%2BWhite%2BBG.png",
      footerLink: [
        { name: "Certification", url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing" },
        { name: "Award Letter", url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing" },
        { name: "Google Code-in Blog", url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html" }
      ]
    },
    {
      title: "Google Assistant Action",
      description: "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Google_Assistant_logo.svg/1200px-Google_Assistant_logo.svg.png",
      footerLink: [{ name: "View Google Assistant Action", url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en" }]
    },

    {
      title: "PWA Web App Developer",
      description: "Completed Certifcation from SMIT for PWA Web App Development",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRu93Bd6LDbxPEOXr-hfLqLYzmHny8c0MJoI3exQP-lwpFLRT7g&s",
      footerLink: [
        { name: "Certification", url: "" },
        { name: "Final Project", url: "https://pakistan-olx-1.firebaseapp.com/" }
      ]
    }
  ]
};

const blogSection = {
  /* Blogs Section */

  title: "Blogs",
  subtitle: "With Love for Developing cool stuff. i love to write and teach others what i have learned",

  blogs: [
    {
      url: "https://medium.com/@nevilledabreo/solution-the-net-cli-tools-cannot-be-located-error-in-visual-studio-code-2ab3c8d88d94",
      image: "https://miro.medium.com/max/2114/1*xnkNEK8XHKYX7EfnmbJ-bA.png",
      title: "SOLUTION — “The .NET CLI tools cannot be located.” error in Visual Studio Code",
      description: "This blog provides the solutions for popular Visual Studio Code Issue."
    },
    {
      url: "https://itnext.io/bower-to-yarn-migration-simple-steps-2a5ad0c43281",
      image: "https://miro.medium.com/max/3840/1*s0R7uSMGfIi1uk7POqkLhQ.jpeg",
      title: "Bower to Yarn Migration (Simple steps)",
      description: "This blog provides the solution to move from Bower."
    }
  ]
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅",

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/",
      image:
        "https://scontent.fkhi6-1.fna.fbcdn.net/v/t1.0-9/76714032_1730516240415559_1293494289556307968_o.jpg?_nc_cat=103&_nc_ohc=s5f81rdZd6wAQmqUa52YQBA21MjVOy7e-HN9jI7MspRDC-v5ahEouyInQ&_nc_ht=scontent.fkhi6-1.fna&oh=c29141a9a0de7ff2011a8191f5475a78&oe=5E83127C"
    }
  ]
};

// Podcast Section
const podcastSection = {
  title: "Podcast 🎙️",
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
};

const contactInfo = {
  title: "Contact Me ☎️",
  subtitle: "Discuss a project or just want to say hi my inbox is open for all",
  number: "+1-(519) 577 0354",
  email_address: "nevile.dabre@gmail.com"
};

export { greeting, socialMediaLinks, skillsSection, openSource, bigProjects, achievementSection, blogSection, talkSection, podcastSection, contactInfo };
